<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('Chodan.Edit.Heading') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field" id="AC">
                            <label for="title2" id="AC2">{{ $t('Emergency1.Edit.Active') }}</label>
                            <InputSwitch v-model="mydata.status" trueValue="active" />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Chodan.Edit.Name') }}</label>
                            <InputText type="text" :class="`${error.coin_package_name ? 'p-invalid' : ''}`"
                                :placeholder="$t('Chodan.Edit.Name')" id="pname" v-model="mydata.coin_package_name" @keydown.space="preventLeadingSpace" disabled>
                            </InputText>
                            <div class="text-red">{{ error.coin_package_name }}</div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{ $t('Chodan.Edit.Coins') }}</label>
                            <InputText type="text" :class="`${error.coin_count ? 'p-invalid' : ''}`"
                                :placeholder="$t('Chodan.Edit.Coins')" id="coins" v-model="mydata.coin_count" @keydown.space="preventLeadingSpace" disabled>
                            </InputText>

                            <div class="text-red">{{ error.coin_count }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{ $t('Chodan.Edit.GoogleCodes') }}</label>
                            <InputText type="text" :class="`${error.play_store_product_id ? 'p-invalid' : ''}`"
                                :placeholder="$t('Chodan.Edit.GoogleCodes')" id="title2"
                                v-model="mydata.play_store_product_id" @keydown.space="preventLeadingSpace">
                            </InputText>
                            <div class="text-red">{{ error.play_store_product_id }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Chodan.Edit.AppleCode') }}</label>
                            <InputText type="text" :class="`${error.app_store_product_id ? 'p-invalid' : ''}`"
                                :placeholder="$t('Chodan.Edit.AppleCode')" id="title2"
                                v-model="mydata.app_store_product_id" @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.app_store_product_id }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Chodan.Edit.Save')" icon="pi pi-check" iconPos="left"
                    class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('Chodan.Edit.Back')" icon="pi pi-replay" iconPos="left"
                    class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black;"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>
<script>
// import validateEditUser from '../../validations/user/validateEditUser';
import validateEditCoins from '../../../validations/Coins/validateEditCoins';
import CoinService from '../../../service/API/CoinService';
import moment from 'moment';
// import axios from 'axios';
export default {
    data() {
        return {
            dropdownValues: [{ name: 'active' }, { name: 'inactive' }],
            dropdownItem: null,
            // modelname: JSON.parse(localStorage.getItem('desc')).description,

            mydata: {
                app_store_product_id: '',
                coin_count: '',
                play_store_product_id: '',
                status: '',
                coin_package_name: ''

            },
            id: '',
            error: {},
            formData: new FormData(),
        };
    },
    created() {
        this.coinService = new CoinService();
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        cancel() {
            // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, "");
        },
        SubmitForm() { },
        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    let vcheckData = {
                        coin_package_name: this.mydata.coin_package_name,
                        coin_count: this.mydata.coin_count,
                        play_store_product_id: this.mydata.play_store_product_id,
                        app_store_product_id: this.mydata.app_store_product_id,
                        // status: this.mydata.status ? 'active' : 'inactive',
                        //     file: this.image == '' ? '' : 'something',
                    };
                    const { isInvalid, error } = validateEditCoins(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        // this.formData.append('coin_package_name', this.mydata.coin_package_name);
                        // this.formData.append('coin_count', this.mydata.coin_count);
                        // this.formData.append('play_store_product_id', this.mydata.play_store_product_id);
                        // this.formData.append('app_store_product_id', this.mydata.app_store_product_id);
                        // this.formData.append('coin_id', this.$route.params.id);
                        // this.formData.append('status', this.mydata.status === undefined ? (this.mydata.status == '활성' ? 'active' : 'inactive') : this.mydata.status);
                        this.coinService.updateCoin({ coin_id: this.$route.params.id, coin_package_name: this.mydata.coin_package_name.toString(), coin_count: this.mydata.coin_count.toString(), play_store_product_id: this.mydata.play_store_product_id.toString(), app_store_product_id: this.mydata.app_store_product_id.toString(), status: this.mydata.status == 'active' ? 'active' : 'inactive' }).then((res) => {
                            console.warn(res);
                            this.$router.push({ name: 'Chodan Coin' });
                            setTimeout(() => {
                                this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '초코 정보가 변경되었습니다.', life: 3000 });
                            }, 500);
                        });
                        // console.log(this.formData);
                        // return axios.post('/api/v1/admin/chodan-coin/edit', this.formData).then((res) => {
                        //     this.$router.push({ name: 'Chodan Coin' });
                        //     setTimeout(() => {
                        //         self.$toast.add({ severity: 'success', summary: '확인.', detail: 'Coin Updated Successfully.', life: 3000 });
                        //     }, 500);

                        //     console.log(res);
                        // });
                    }
                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },

        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
    },
    mounted() {
        this.coinService.viewCoin(this.$route.params.id).then((res) => {
            this.mydata.status = res.status;
            this.mydata.coin_package_name = res.coin_package_name;
            this.mydata.coin_count = res.coin_count;
            this.mydata.app_store_product_id = res.app_store_product_id;
            this.mydata.play_store_product_id = res.play_store_product_id;
            // this.mydata.validity_date = res[0].validity_date;
            console.log(res);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

div#AC {
    display: flex;
}

label#AC2 {
    margin-right: 12px;
}
#Save{
    background: black;
    color: white;
}
input#pname {
    background: darkgray;
    color: black;
}
input#coins {
    background: darkgray;
    color: black;
}
</style>
